import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';


export const selectTimezone = (state: IRootMachineSnapshot) => {
  return state.context.timezone;
};
